export default __webpack_public_path__ + "static/media/family.011adb45.jpg";